module.exports = __webpack_public_path__ + "static/media/apng_gryphon.3c826c54.png";